import { CircularProgress, useTheme } from "@mui/material";
import React from "react";

type ProgressIndicatorProps = {
  size: number;
  dataTestId?: string;
};

export const ProgressIndicator = (props: ProgressIndicatorProps) => {
  const { size, dataTestId } = props;
  const sizeInPx = `${size}px`;

  const theme = useTheme();

  return (
    <CircularProgress
      data-testid={dataTestId}
      style={{
        maxHeight: sizeInPx,
        maxWidth: sizeInPx,
        height: sizeInPx,
        width: sizeInPx,
        marginLeft: "auto",
        marginRight: "auto",
        color: theme.palette.secondary.dark,
      }}
    />
  );
};
